/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpRespSidebarContact_displayInfo$ref = any;
export type PdpRespSidebarContact_displayInfo = {
    readonly pricing: {
        readonly showSold: boolean | null;
        readonly showUnavailable: boolean | null;
    } | null;
    readonly " $refType": PdpRespSidebarContact_displayInfo$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSidebarContact_displayInfo",
  "type": "ItemDisplayInfo",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "pricing",
      "storageKey": null,
      "args": null,
      "concreteType": "PriceInfoDisplay",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showSold",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showUnavailable",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = 'f182d826b777d6b4adf124d05d0e1186';
export default node;
